export default __webpack_public_path__ + "static/media/amandamakke.6d8901ca.webp";